interface CheckBoxNodeValues {
  id: string,
  label: string,
  texts?: Record<string, string>,
  value: boolean,
  metadata?: Record<string, string | number | object>,
}

export class CheckBoxNode {
  constructor(
    public id: string,
    public label: string,
    public texts: Record<string, string>,
    public value: boolean,
    public metadata?: Record<string, string | number | object>,
  ) {}

  public static copy(other: CheckBoxNodeValues) {
    const texts: CheckBoxNode['texts'] = {
      es: other.label,
    }
    if (other.texts) {
      Object.entries(other.texts).forEach(([key, value]) => {
        texts[key] = value
      })
    }

    return new CheckBoxNode(
      other.id,
      other.label,
      texts,
      other.value,
      other.metadata,
    )
  }
}
